module.exports = __webpack_public_path__ + "static/media/dispatched.8452a67c.svg";